import {
  Archive,
  Boxes,
  ClipboardCheck,
  FileBarChart,
  Gauge,
  Laptop,
  PackageOpen,
  Settings,
  ShieldCheck,
  Users,
  Wrench,
} from "lucide-react";
import type { LucideIcon } from "lucide-react";
import type { Permission } from "@/lib/permissions";
import type { NomePerfil } from "@/types";

export interface NavigationItem {
  title: string;
  path: string;
  icon: LucideIcon;
  profiles?: NomePerfil[];
  permission?: Permission;
}

export interface NavigationGroup {
  id: string;
  title: string;
  items: NavigationItem[];
}

export const APP_NAME = "Gestão de T.I.";

export const navigationItems: NavigationItem[] = [
  { title: "Dashboard", path: "/", icon: Gauge },
  { title: "Equipamentos", path: "/equipamentos", icon: Laptop },
  { title: "Suprimentos", path: "/suprimentos", icon: Boxes },
  { title: "Colaboradores", path: "/colaboradores", icon: Users },
  { title: "Manutenções", path: "/manutencoes", icon: Wrench },
  { title: "Licenças", path: "/licencas", icon: ShieldCheck },
  { title: "Inventários", path: "/inventarios", icon: ClipboardCheck },
  { title: "Relatórios", path: "/relatorios", icon: FileBarChart },
  { title: "Auditoria", path: "/auditoria", icon: Archive, profiles: ["Administrador"] },
  { title: "Usuários", path: "/usuarios", icon: Users, profiles: ["Administrador"] },
  { title: "Configurações", path: "/configuracoes", icon: Settings, profiles: ["Administrador"] },
];

export const navigationGroups: NavigationGroup[] = [
  {
    id: "principal",
    title: "Principal",
    items: [{ title: "Dashboard", path: "/", icon: Gauge }],
  },
  {
    id: "gestao-ti",
    title: "Gestão de T.I.",
    items: [
      { title: "Equipamentos", path: "/equipamentos", icon: Laptop },
      { title: "Suprimentos", path: "/suprimentos", icon: Boxes },
      { title: "Colaboradores", path: "/colaboradores", icon: Users },
      { title: "Licenças", path: "/licencas", icon: ShieldCheck },
      { title: "Manutenções", path: "/manutencoes", icon: Wrench },
      { title: "Inventários", path: "/inventarios", icon: ClipboardCheck },
      { title: "Relatórios", path: "/relatorios", icon: FileBarChart, permission: "relatorios" },
    ],
  },
  {
    id: "administracao",
    title: "Administração",
    items: [
      { title: "Usuários", path: "/usuarios", icon: Users, permission: "usuarios" },
      { title: "Perfis e permissões", path: "/perfis-permissoes", icon: ShieldCheck, permission: "usuarios" },
      { title: "Auditoria", path: "/auditoria", icon: Archive, permission: "auditoria" },
      { title: "Configurações", path: "/configuracoes", icon: Settings, permission: "configuracoes" },
    ],
  },
];

export const profileLabels: Record<NomePerfil, string> = {
  Administrador: "Administrador",
  "Gestor de TI": "Gestor de TI",
  "Técnico de TI": "Técnico de TI",
  Consulta: "Consulta",
};

export const initialDashboardCards = [
  { label: "Equipamentos", icon: Laptop },
  { label: "Itens em estoque", icon: PackageOpen },
  { label: "Colaboradores", icon: Users },
];
